module.exports = __webpack_public_path__ + "img/cluster.6010817b.svg";